// src/features/medicine-inventory/components/stock/StockMovementForm.jsx
import React, { useState } from 'react';
import { useInventory } from '../../context/InventoryContext';

const StockMovementForm = ({ onClose }) => {
  const { medicines, addStockMovement } = useInventory();
  const [movementType, setMovementType] = useState('PURCHASE');
  const [formData, setFormData] = useState({
    medicineId: '',
    type: 'PURCHASE',
    quantity: '',
    unitPrice: '',
    patientName: '',
    prescriptionNumber: '',
    doctorName: '',
    reference: '',
    notes: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleTypeChange = (type) => {
    setMovementType(type);
    setFormData(prev => ({
      ...prev,
      type,
      patientName: '',
      prescriptionNumber: '',
      doctorName: '',
      reference: ''
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const selectedMedicine = medicines.find(m => m.id === formData.medicineId);
      
      const movementData = {
        ...formData,
        quantity: parseInt(formData.quantity),
        unitPrice: parseFloat(formData.unitPrice),
        totalPrice: parseInt(formData.quantity) * parseFloat(formData.unitPrice)
      };

      await addStockMovement(movementData);
      onClose();
    } catch (error) {
      console.error('Failed to record movement:', error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const selectedMedicine = medicines.find(m => m.id === formData.medicineId);

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Movement Type
        </label>
        <div className="flex space-x-4">
          <button
            type="button"
            onClick={() => handleTypeChange('PURCHASE')}
            className={`flex-1 py-2 px-4 rounded-lg border transition-colors ${
              movementType === 'PURCHASE'
                ? 'bg-green-600 text-white border-green-600'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            }`}
          >
            Purchase
          </button>
          <button
            type="button"
            onClick={() => handleTypeChange('ISSUE')}
            className={`flex-1 py-2 px-4 rounded-lg border transition-colors ${
              movementType === 'ISSUE'
                ? 'bg-red-600 text-white border-red-600'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            }`}
          >
            Issue to Patient
          </button>
        </div>
      </div>

    

      <div className="grid grid-cols-2 gap-4">
          <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Medicine <span className="text-red-500">*</span>
        </label>
        <select
          name="medicineId"
          required
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={formData.medicineId}
          onChange={handleChange}
        >
          <option value="">Select Medicine</option>
          {medicines.map(medicine => (
            <option key={medicine.id} value={medicine.id}>
              {medicine.name} - {medicine.manufacturer} (Stock: {medicine.currentStock} {medicine.unit}s)
            </option>
          ))}
        </select>
      </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Quantity <span className="text-red-500">*</span>
          </label>
          <input
            type="number"
            name="quantity"
            required
            min="1"
            max={movementType === 'ISSUE' ? selectedMedicine?.currentStock : undefined}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={formData.quantity}
            onChange={handleChange}
            placeholder="Enter quantity"
          />
          {movementType === 'ISSUE' && selectedMedicine && (
            <p className="text-xs text-gray-500 mt-1">
              Available stock: {selectedMedicine.currentStock} {selectedMedicine.unit}s
            </p>
          )}
        </div>

        {/* <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Unit Price ($) <span className="text-red-500">*</span>
          </label>
          <input
            type="number"
            name="unitPrice"
            required
            min="0"
            step="0.01"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={formData.unitPrice}
            onChange={handleChange}
            placeholder="0.00"
          />
        </div> */}
      </div>

      {movementType === 'PURCHASE' ? (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Purchase Order Reference
          </label>
          <input
            type="text"
            name="reference"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={formData.reference}
            onChange={handleChange}
            placeholder="Enter PO number"
          />
        </div>
      ) : (
        <>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Patient Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="patientName"
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={formData.patientName}
              onChange={handleChange}
              placeholder="Enter patient name"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Prescription Number
              </label>
              <input
                type="text"
                name="prescriptionNumber"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={formData.prescriptionNumber}
                onChange={handleChange}
                placeholder="Optional"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Doctor Name
              </label>
              <input
                type="text"
                name="doctorName"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={formData.doctorName}
                onChange={handleChange}
                placeholder="Optional"
              />
            </div>
          </div>
        </>
      )}

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Notes
        </label>
        <textarea
          name="notes"
          rows="2"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={formData.notes}
          onChange={handleChange}
          placeholder="Add any additional notes"
        />
      </div>

      {/* {formData.quantity && formData.unitPrice && (
        <div className="bg-gray-50 p-3 rounded-lg">
          <p className="text-sm font-medium text-gray-700">
            Total Amount: <span className="text-lg font-bold text-blue-600">
              ${(parseInt(formData.quantity) * parseFloat(formData.unitPrice)).toFixed(2)}
            </span>
          </p>
        </div>
      )} */}

      <div className="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
          disabled={submitting}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={submitting}
        >
          {submitting ? 'Recording...' : 'Record Movement'}
        </button>
      </div>
    </form>
  );
};

export default StockMovementForm;